import React, { createContext, useContext, useState } from "react";
import { useSearchParams } from "react-router-dom";

// Create the context
const ShipmentOrdersContext = createContext();

// Provider component
export const ShipmentOrdersContextProvider = ({ children }) => {
  const [ids, setIds] = useState(new Set());
  const [selectedAll, setSelectedAll] = useState(false);

  // Return Type handling
  const [searchParams, setSearchParams] = useSearchParams();
  const returning = searchParams.get("returning");
  const [returnType, setReturnType] = useState(returning);

  const setReturnHelper = (newValue) => {
    setSearchParams((prev) => {
      const newParams = new URLSearchParams(prev);
      newParams.set("returning", !!newValue);
      return newParams;
    });
    setReturnType(!!newValue);
  };

  const onSelect = (id) => {
    setIds((prev) => {
      const newSet = new Set(prev);
      if (newSet.has(id)) setSelectedAll(false);
      newSet.has(id) ? newSet.delete(id) : newSet.add(id);
      return newSet;
    });
  };

  const onClear = () => {
    setIds(new Set());
    setSelectedAll(false);
  };

  const onSelectAll = (ids, val) => {
    setIds(ids);
    setSelectedAll(val);
  };

  const count = ids.size;
  const getIds = () => Array.from(ids);

  const onShip = () => {
    if (ids.size) {
    }
  };

  return (
    <ShipmentOrdersContext.Provider
      value={{
        ids,
        getIds,
        onSelect,
        count,
        onClear,
        onSelectAll,
        selectedAll,
        onShip,
        returnType,
        setReturnHelper,
      }}
    >
      {children}
    </ShipmentOrdersContext.Provider>
  );
};

// Hook to use the context
export const useShipmentOrdersContext = () => {
  const context = useContext(ShipmentOrdersContext);
  if (!context) {
    throw new Error(
      "useShipmentOrdersContext must be used within a ShipmentOrdersContextProvider"
    );
  }
  return context;
};
